const drawer = {
    leftDrawer: { width: 240 },
    rightDrawer: { width: 260 },
};
export default drawer;
